<template>
	<div>
		<div class="b-box">
			<p>图片上传</p>
			<p>企业地理位置图; 厂区平面布置图; 周边环境风险受体分布图; 企业雨水、清净下水收集、排放管道图、污水收集、排放管道图以及所有排水最终去向图</p>
			

			<viewer :images="fileList2" class="seeBigImg"> 
				<div v-for="(img,index) in fileList2" style="position:relative" class="imglists">
					<img
						:src="img.url"
						:key="index"
					>
					<div class="delete"><i class="el-icon-delete2" @click="handleRemove(img)"></i></div>
			  	</div>
            </viewer>
			<el-upload class="upload-box" action="/api/emer/planich/upload" ref="upload" :headers="headers" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList2" list-type="picture-card" :data="datalist" :on-success="on_success" accept=".png,.jpg,.jpeg" :before-upload="beforeAvatarUpload">
				<i class="el-icon-plus"></i>
			</el-upload>
			<el-dialog :visible.sync="dialogVisible" size="tiny">
				<img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>

		</div>
	</div>
</template>
<script>
	import Burst from './../../data/emer/burst.js'
	export default {
		data() {
			return {
				dialogImageUrl: '',
				photo:[],
				fileList2: [],
				datalist: {
					planId: ''
				},
				dialogVisible: false,
				// 列表
				planich_list: null
			}
		},
		created() {
			if(!sessionStorage.planIdval) return
			this.datalist.planId = sessionStorage.planIdval
			this.planich()
		},
		methods: {
			// 验证`
			verifyPlan() {
				//this.planich()
				if(!this.fileList2.length) {
					return {
						status: false,
						msg: '平面图上传不完善，请上传'
					}
				}
				return {
					status: true,
					msg: 'ok'
				}
			},
			// 格式限制
			beforeAvatarUpload(file) {
				let limit = ['png','jpg','jpeg'];
				let extension = file.name.split('.')[1];
				if(!extension || !limit.includes(extension.toLowerCase())) {
					this.$message.error('支持图片PNG/JPG/JPEG')
					return false;
				}
				return true;
			},
			// 成功
			on_success(response, file, fileList) {
				this.$message.success('文件上传成功')
				this.planich()
			},
			// 移除
			handleRemove(file, fileList) {
				let id = file.id ? file.id : file.response ? file.response.id: '';
				if(!id){
					return;
				}
				this.remove({
					id: id
				})
				setTimeout(() => {
					this.planich()
				}, 500)

			},
			// 大图
			handlePreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
				this.photo.push(file.url)
			},

			// 获取平面图信息
			planich() {
				(async() => {
					let pID = sessionStorage.planIdval
					try {
						let plan = await Burst.planich_list({
							planId: pID
						})
						if(plan.status) {
							let newList = []
							plan.data.map((item) => {
								newList.push({
									name: item.fileName,
									url: `/api/emer/planich/download?id=${item.id}&isOnline=true`,
									id: item.id
								})
							})
							this.fileList2 = newList

						}
					} catch(error) {
						this.$message.error(error)
					}
				})()
			},
			// 删除文件
			remove(params) {
				(async() => {
					try {
						let info = await Burst.remove_planich(params)
						if(info.status) {
							this.$message.success('文件删除成功')
						}
					} catch(err) {
						console.log('文件删除失败')
					}
				})()
			},
		},
		computed:{
			headers(){
				return {
				'Authorization': 'Bearer '+ sessionStorage.getItem('publicToken')
				}
			}
		},		
	}
</script>
<style scoped lang="stylus">
	.b-box {
		p {
			font-size: 14px;
			margin-bottom: 20px;
			margin-top: 10px;
			&:first-child {
				font-weight: bold;
			}
		}
	}

</style>


// WEBPACK FOOTER //
// planImg.vue?ea268cc4